import { render, staticRenderFns } from "./screen-base.vue?vue&type=template&id=da0d4bf0"
import script from "./screen-base.vue?vue&type=script&lang=ts"
export * from "./screen-base.vue?vue&type=script&lang=ts"
import style0 from "./screen-base.vue?vue&type=style&index=0&id=da0d4bf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports